<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <v-select
            v-model="currentObject"
            :options="articleCategories"
            :loading="isLoading || booting"
            label="title"
            ref="selector"
        ></v-select>
    </div>
</template>

<script>
import fieldInfo from './../mixins/fieldInfo';
import vSelect from 'vue-select';

export default {
    name: "ArticleCategorySelect",
    components: {
        vSelect
    },
    mixins: [
        fieldInfo,
    ],
    data: function () {
        return {
            booting: true,
            currentObject: null,
        }
    },
    methods: {
        setObject(articleCategory) {
            this.currentValue = articleCategory ? articleCategory.id : null;
            this.booting = false;
        }
    },
    computed: {
        articleCategories() {
            return this.$store.state.composer.articleCategories;
        },
        isLoading() {
            return this.$store.getters.isLoading('articleCategories');
        }
    },
    watch: {
        currentObject(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.setObject(newValue);
            }
        }
    },
    created(){
        this.$store.dispatch('boot', 'getArticleCategories').then(() => {
            this.booting = false;
            this.currentObject = this.value;
        });
    }
}
</script>
